import React from "react";
import Block5 from "../Block5";
import SubHeading from "../SubHeading";

const LatestArticles = () => {
  return (
    <>
      {/* BLOCK */}
      <div className="p-4 md:p-0 mb-6">
          <SubHeading text="latest articles" color="black" />
          
          {/* Content */}
          <div className="flex flex-col md:flex-row flex-wrap">
            <div className="w-full md:w-1/2 p-1 md:pr-10 py-5">
                <Block5 />
            </div>
            <div className="w-full md:w-1/2 p-1 md:pr-10 py-5">
                <Block5 />
            </div>
            <div className="w-full md:w-1/2 p-1 md:pr-10 py-5">
                <Block5 />
            </div>
            <div className="w-full md:w-1/2 p-1 md:pr-10 py-5">
                <Block5 />
            </div>
          </div>
      </div>
    </>
  );
};

export default LatestArticles;
